import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
  ranking: number;
  img: string;
  name: string;
  points: number;
};

export const ScoreCard: FC<Props> = ({ className = '', ranking, img, name, points }) => {
  return (
    <div className={twMerge('py-2 px-4 bg-white rounded-xl flex flex-row justify-between items-center', className)}>
      <div className="flex flex-row items-center gap-3">
        <p className="text-black text-xl font-semibold">{ranking}</p>
        <img className="w-10 h-10" src={img} alt={`${name} som kom på ${ranking} pladsen`} />
        <p className="w-[35vw] truncate text-black font-semibold">{name}</p>
      </div>
      <p className="text-black">{points} pts</p>
    </div>
  );
};
